import { Table } from 'antd';
import Utils from '~commons/utils';

const Tickets = ({ ticketList }) => {
  const columns = [
    {
      title: 'Số phiếu',
      dataIndex: 'aid',
      align: 'center',
      // width: 100,
    },
    {
      title: 'Folder',
      dataIndex: 'folder',
      // width: 100,
      align: 'center',
    },
    {
      title: 'SubNo',
      dataIndex: 'subnoNumber',
      // width: 150,
      align: 'center',
    },
    {
      title: 'Khách hàng',
      dataIndex: 'customerName',
      // width: 150,
      align: 'center',
    },
    {
      title: 'Ngày điều xe',
      dataIndex: 'assignDate',
      // width: 120,
      align: 'center',
      render: (val) => Utils.formatDate(val),
    },
    {
      title: 'Ngày giải trừ',
      dataIndex: 'dissolveDate',
      // width: 120,
      align: 'center',
      render: (val) => Utils.formatDate(val),
    },
    {
      title: 'Số tiền',
      dataIndex: 'total',
      align: 'center',
      render: (val) => val && Utils.formatNumber(val),
      // width: 100,
    },
    {
      title: 'Người giải trừ',
      dataIndex: 'createdBy',
      align: 'center',
      // width: 100,
    },
    {
      title: 'Ghi chú',
      dataIndex: 'note',
      align: 'center',
      // width: 100,
    },
  ];

  return (
    <div
      className='table-container-custom'
      style={{
        maxHeight: 'calc(100vh - 590px)',
        overflow: 'auto',
      }}
    >
      <Table
        bordered
        size='small'
        columns={columns}
        dataSource={ticketList}
        rowKey='id'
        // scroll={{
        //   x: '100%',
        //   y: 'calc(100vh - 480px)',
        // }}
        pagination={false}
      />
    </div>
  );
};
export { Tickets };
